import React, { useMemo, useCallback, useState, useEffect } from 'react';
import { range } from 'lodash-es';
import styled from '../../../../styled';
import Text from '../../../text';
import { ColumnButton } from '../../date/Calendar/Column';
import dayjs from '../../date/day';
import { HOUR_FORMAT, getDefaultTimeText } from '..';
const Container = styled.div `
  display: flex;
`;
const Grid = styled.div `
  width: 3.75rem;
  max-height: 17.875rem;
  overflow-y: scroll;

  &:not(:first-child) {
    border-left: 0.0625rem solid ${({ theme }) => theme.colors.INK_200};
  }
`;
const Column = styled(ColumnButton) `
  width: 100%;
  height: 2.755rem;

  :hover {
    border-radius: 0;
  }
`;
const Header = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3rem;
  border-bottom: 0.0625rem solid ${({ theme }) => theme.colors.INK_200};

  > span {
    font-weight: 600;
  }
`;
const getHourString = (hour) => hour.toString().padStart(2, '0');
const TimeSelector = ({ lang, format, inputValue, selectedDate, onSelect, minuteInterval, }) => {
    const hours = new Array(12).fill(null).map((_, i) => i + 1);
    const [selectedMode, setSelectedMode] = useState();
    const [selectedHour, setSelectedHour] = useState();
    const [selectedMinute, setSelectedMinute] = useState();
    const minuteOptions = useMemo(() => {
        if (!minuteInterval)
            return [];
        const steps = [0, ...range(minuteInterval, 60, minuteInterval)];
        return steps.map(step => `${step}`.padStart(2, '0'));
    }, [minuteInterval]);
    const isDisabled = !inputValue;
    useEffect(() => {
        if (selectedMode && selectedHour && (!minuteInterval || selectedMinute)) {
            let targetHour = selectedHour;
            if (selectedMode === 'AM' && selectedHour === 12) {
                targetHour = 0;
            }
            else if (selectedMode === 'PM' && selectedHour !== 12) {
                targetHour = selectedHour + 12;
            }
            let newDate = selectedDate ||
                dayjs(lang, inputValue, format.replace(` ${HOUR_FORMAT}`, ''));
            if (targetHour >= 0) {
                newDate = newDate.hour(targetHour);
            }
            if (selectedMinute) {
                newDate = newDate.minute(parseInt(selectedMinute, 10));
            }
            // NOTE: To avoid dayjs to Date will produce strange milliseconds
            newDate = newDate.millisecond(0);
            onSelect(newDate);
        }
    }, [selectedMode, selectedHour, selectedMinute]);
    const handleModeClick = useCallback((mode) => () => {
        if (isDisabled)
            return;
        setSelectedMode(mode);
    }, [isDisabled]);
    const handleHourClick = useCallback((hour) => () => {
        if (isDisabled)
            return;
        setSelectedHour(hour);
    }, [isDisabled]);
    const handleMinuteClick = useCallback((minute) => () => {
        if (isDisabled)
            return;
        setSelectedMinute(minute);
    }, [isDisabled]);
    useEffect(() => {
        // update state when props updated
        if (selectedDate && dayjs(lang, inputValue, format).isValid()) {
            const hour = selectedDate.hour();
            setSelectedMode(hour < 12 ? 'AM' : 'PM');
            setSelectedHour(hour === 0 || hour > 12 ? Math.abs(hour - 12) : hour);
            if (minuteInterval) {
                const minute = selectedDate.minute();
                setSelectedMinute(`${minute}`.padStart(2, '0'));
            }
        }
        else if (isDisabled) {
            setSelectedMode(undefined);
            setSelectedHour(undefined);
            setSelectedMinute(undefined);
        }
    }, [lang, format, inputValue, selectedDate, isDisabled]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement(Text, { lang: lang, fontType: "Subheading", color: "INK_800" }, getDefaultTimeText(lang))),
        React.createElement(Container, null,
            React.createElement(Grid, null, hours.map((hour) => (React.createElement(Column, { key: `${selectedMode}-${hour}`, isSelected: hour === selectedHour, isDisabled: isDisabled, onClick: handleHourClick(hour) }, getHourString(hour))))),
            minuteInterval && (React.createElement(Grid, null, minuteOptions.length > 0 &&
                minuteOptions.map(minuteOption => (React.createElement(Column, { key: minuteOption, isSelected: selectedMinute === minuteOption, isDisabled: isDisabled, onClick: handleMinuteClick(minuteOption) }, minuteOption))))),
            React.createElement(Grid, null,
                React.createElement(Column, { isSelected: selectedMode === 'AM', isDisabled: isDisabled, onClick: handleModeClick('AM') }, "am"),
                React.createElement(Column, { isSelected: selectedMode === 'PM', isDisabled: isDisabled, onClick: handleModeClick('PM') }, "pm")))));
};
export default TimeSelector;
//# sourceMappingURL=TimeSelector.js.map